import React from "react";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Login from "./components/Login"
function App() {
  const router = createBrowserRouter([
    { path: "/", element: <Navigate to="/hrms" replace /> },
    { path: "/:platform", element: <Login /> },
  ]);
  
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
